import { useState, useEffect } from 'react';

const useFormUser = (callback, validate, data) => {

  const [values, setValues] = useState(data);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [errors, isSubmitting]);

  /*
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      setErrors(validate(values));
    }
  }, [errors, values]);
  */

  const handleSubmit = (event) => {

    event.preventDefault();
    if (event) {
      setErrors(validate(values));
      setIsSubmitting(true);
    }
  };

  const handleChange = (event) => {
  
    event.persist();
    setValues(values => ({ ...values, [event.target.name]: event.target.value }));

  };

  return {
    handleChange,
    handleSubmit,
    values,
    errors,
    setValues
  }
};

export default useFormUser;